export function multiplyAndRound(num, mult) {
	let result = (num * mult).toFixed(2);
	return parseFloat(result);
}
